export default __webpack_public_path__ + "static/media/GS_calender_icon.8b194107.svg";